module.exports = __webpack_public_path__ + "static/media/SFRIcon.f8a9788a.png";